<template>
  <div class="sidebar-user">
    <section v-show="profilesVisible">
      <div class="bar-profile" @click.stop="showProfiles">
        <b-icon icon="arrow-left" class="mr-10" />
        <span>{{ General.CHANGE_SECTOR }}</span>
      </div>
      <b-field :type="listFilterProfile.length ? '' : 'is-danger'">
        <b-input
          v-model="filterProfile"
          :placeholder="`${General.TYPE_IT_SEARCH}...`"
          class="m-5"
        />
      </b-field>
      <div
        v-for="(capacity, index) in listFilterProfile"
        :key="`${capacity.capacity_id}_${index}_sidebar`"
        class="profile-item"
        :value="capacity.capacity_id"
        aria-role="listitem"
        @click="selectProfile(capacity)"
      >
        <p>{{ General.PROFILE }} {{ index + 1 }}</p>
        {{ formatCapacity(capacity) }}
      </div>
      <div v-if="!listFilterProfile.length" class="profile-item">
        {{ General.MESSAGES.NO_RECORDS_FOUND }}
      </div>
    </section>
    <section v-show="!profilesVisible">
      <section class="is-flex p-5">
        <div class="user-profile-block has-text-color-8">
          <img
            src="../assets/svg/user-circle.svg"
            alt="Perfil do usuário"
            width="50"
          />
          <div>
            <b>{{ user.name }}</b>
            <div v-if="user.capacity.category_description">
              {{ user.capacity.category_description }}
            </div>
            <div v-else-if="user.capacity.is_secondary">
              {{ General.SECONDARY_CAPACITY.toUpperCase() }}
            </div>
            <div v-if="user.capacity.capacity_abbreviation">
              {{ formatCapacity(user.capacity) }}
            </div>
            <div v-else>
              {{ General.WITHOUT_CAPACITY }}
            </div>
            <b-button
              :type="isContrast ? 'is-white' : 'is-green-dark'"
              outlined
              class="has-text-weight-bold mt-5"
              @click.stop="showProfiles"
            >
              {{ General.CHANGE_SECTOR.toLowerCase() }}
            </b-button>
          </div>
        </div>
        <span class="close" @click="closeSidebar">
          <b-icon icon="close-thick" />
        </span>
      </section>
      <section class="list">
        <routerLink
          class="dropdown-item"
          role="link"
          rel="search external"
          to="/app/configuracoes-usuario"
          @click.native="closeSidebar"
        >
          <b-icon icon="cog-outline" class="mx-5" />
          <b> {{ General.MY_USER_AREA }} </b>
        </routerLink>
        <routerLink
          class="dropdown-item"
          role="link"
          rel="search external"
          :to="{
            path: '/app/configuracoes-usuario',
            query: { activeTab: 'notifications-config' }
          }"
          @click.native="closeSidebar"
        >
          <b-icon icon="bell-cog-outline" class="mx-5" />
          <b> {{ General.MANAGE_NOTIFICATION }} </b>
        </routerLink>
        <routerLink
          class="dropdown-item"
          role="link"
          rel="search external"
          to="/app/feedback"
          @click.native="closeSidebar"
        >
          <b-icon icon="message-text" class="mx-5" />
          <b> {{ General.SEND_FEEDBACK }} </b>
        </routerLink>
        <routerLink
          class="dropdown-item"
          role="link"
          rel="search external"
          to="/"
          target="_blank"
          @click.native="closeSidebar"
        >
          <b-icon icon="home-variant-outline" class="mx-5" />
          <b> {{ General.GO_TO_SITE }} </b>
        </routerLink>
        <a
          class="dropdown-item"
          role="link"
          rel="noopener search external"
          href="https://suite.seplag.ce.gov.br/"
          target="_blank"
        >
          <b-icon icon="help-circle" class="mx-5" />
          <b> {{ App.Channel.HELP_CENTER }} </b>
        </a>
        <div @click="logout">
          <b-icon
            icon="login"
            :type="isContrast ? 'is-white' : 'is-blue-oil'"
            class="mx-5"
          />
          <span class="has-text-color-7"
            ><b> {{ General.LOG_OUT }} </b></span
          >
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { App, General } from "@/utils/constants";

export default {
  name: "UserHeaderMenuContent",
  props: {
    toggleCollapse: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      App,
      General,
      filterProfile: "",
      profilesVisible: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getCurrentUser",
      isContrast: "isContrast"
    }),

    listFilterProfile() {
      const regExp = RegExp(this.filterProfile, "i");
      return this.user.bonds.filter(
        bond =>
          regExp.test(
            `${bond.part_abbreviation}/${
              bond.capacity_abbreviation.includes("/")
                ? bond.capacity_abbreviation.split("/", -1)[1]
                : bond.capacity_abbreviation
            }`
          ) && bond.active
      );
    }
  },
  methods: {
    ...mapActions({
      updateDefaultProfile: "updateDefaultProfile"
    }),

    ...mapMutations({
      setViewSector: "setViewSector"
    }),

    formatCapacity(capacity) {
      return `${capacity.part_abbreviation}/${
        capacity.capacity_abbreviation.includes("/")
          ? capacity.capacity_abbreviation.split("/", -1)[1]
          : capacity.capacity_abbreviation
      }`.toUpperCase();
    },

    logout() {
      this.toggleCollapse();
      this.$store.dispatch("authLogout", "Usuário deslogado com sucesso.");
    },

    closeSidebar() {
      this.toggleCollapse();
    },

    showProfiles() {
      this.profilesVisible = !this.profilesVisible;
    },

    async selectProfile(capacity) {
      this.profilesVisible = false;
      this.toggleCollapse();
      this.filterProfile = "";
      const result = await this.updateDefaultProfile(capacity.capacity_id);
      if (result) {
        this.$router.push("/app");
        this.setViewSector("INDIVIDUAL");
        this.snackToast.open({
          message: `${this.General.MESSAGES.CHANGE_UNITY_TO} ${
            capacity.part_abbreviation
          }/${
            capacity.capacity_abbreviation.includes("/")
              ? capacity.capacity_abbreviation.split("/", -1)[1]
              : capacity.capacity_abbreviation
          }`,
          type: "is-success",
          duration: 8000
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.sidebar-user {
  .user-profile-block {
    width: calc(100% - 30px);
    display: grid;
    grid-template-columns: 60px auto;
    margin-top: 5px;
    img {
      margin: 3px;
    }
  }
  .close {
    cursor: pointer;
    background-color: #dcdcdc78;
    width: 25px;
    height: 25px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .list {
    margin-top: 10px;
    div,
    a {
      display: flex;
      padding: 10px 5px;
      border-top: 1px solid $border-color;
      width: 100%;
      font-size: 1rem;
    }
  }
  .bar-profile {
    display: flex;
    padding: 5px 10px;
    font-weight: 600;
    background-color: $custom-color-f2f2f2;
  }
  .profile-item {
    font-weight: 600;
    padding: 10px 15px;
    border-bottom: 1px solid $border-color;
  }
}
</style>
